module.exports = __webpack_public_path__ + "img/grunt-color.9ee64b39.svg";